export const extractErrorMessage = (error)  => {
  if (typeof error === 'string') return error

  if (error instanceof Error) return error.message;

  if (error && typeof error === 'object') {
    if ('response' in error && error.response && typeof error.response === 'object') {
      const response = error.response;
      if (response.data) {
        if (typeof response.data === 'string') return response.data.message;
        if (typeof response.error === 'string') return response.data.error;
        if (Array.isArray(response.data.errors) && response.data.errors.length > 0) {
          return response.data.errors.join(', ');
        }
      }
      if (response.statusText) return `${response.status}:${response.statusText}`;
    }
    if ('statusText' in error && typeof error.statusText === 'string') {
      return error.statusText;
    }
    try {
      const stringified = JSON.stringify(error);
      if (stringified !== "[object Object]") {
        return stringified
      }
    } catch (e) {
      
    }
  }
  return "An unexpected error occurred";
}